import injectSheet from 'react-jss';

import ChartBar from './component';
import styles from './styles';

export default injectSheet(styles)(ChartBar);
